import { CarInput } from '../../graphql';

const requiredFields: readonly (keyof CarInput)[] = ['color', 'make', 'model'];

export const isCarInput = (input: Partial<CarInput>): input is CarInput =>
	requiredFields.every(field => input[field] !== undefined);
